import {Component} from '@angular/core';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'video-busy-indicator',
    templateUrl: 'video-busy-indicator.component.html',
    styleUrls: ['video-busy-indicator.service.scss']
})
export class VideoBusyIndicatorComponent { }


// WEBPACK FOOTER //
// ./src/app/youtube-video/video-loading/video-busy-indicator.component.ts